import React from "react";
import classnames from "classnames";
import LicenseStrip from "./license-strip";
import LicenseDisplay from "./license-display";
import { licenses } from "../../reducers/download";

const PhaseUpsell = props => {
    return (
        <div className="upsell-container">
            <h2 className="header">We like your style!</h2>
            <p>Customizing icons requires a Pro purchase.</p>
            <ul className="license-choices">
                <LicenseDisplay license={licenses.ROYALTY_FREE} />
            </ul>
            <div className="download-actions vertical">
                <div
                    className="button blue accept"
                    onClick={props.downloadDoUpsell}
                >
                    Keep edits with Pro
                </div>
                <div
                    className="button reject"
                    onClick={props.downloadNoPremiumFeatures}
                >
                    Lose my edits
                </div>
            </div>
        </div>
    );
};

export default PhaseUpsell;
